export default function ForwardArrow({ type = "dark" }) {
  if (type === "dark") {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12.5" r="12" fill="#1F2022" stroke="#1F2022" />
        <path
          d="M12.1366 7.19932L17.3357 12.3984L12.1366 17.5975"
          stroke="white"
        />
        <line
          x1="17.3359"
          y1="12.6758"
          x2="6.6698"
          y2="12.6758"
          stroke="white"
        />
      </svg>
    );
  }

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12.5" r="12" fill="" stroke="#1F2022" />
      <path
        d="M12.1366 7.19932L17.3357 12.3984L12.1366 17.5975"
        stroke="#1F2022"
      />
      <line
        x1="17.3359"
        y1="12.6758"
        x2="6.6698"
        y2="12.6758"
        stroke="#1F2022"
      />
    </svg>
  );
}
